import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DATA } from './checkbox-data';
import { useUpdater } from '@td/shared_utils';
import { authToken } from '@td/api';
import { defaultCheckboxValues } from '../../constants/preference-types';
import CheckboxWithTooltip from '../../../utility/checkbox-with-tooltip';

const PreferenceActionBox = ({ locales: { headerTitle, submitButton, toolTipContent } }) => {
  const { notifyBox: { title, properties },
          additionalBox: { title: additionaltitle, properties: additionalProperties } } = DATA;
  const [checkBoxItems, setCheckBoxItems] = useState(defaultCheckboxValues);

  const TOOLTIP_CONFIG = {
    className: 'preference-info-tooltip',
    iconFill:  '#727069',
    multiline: true,
    effect:    'float',
    size:      '1rem',
    id:        'notification',
    info:      toolTipContent
  };

  const onChangeCheckBox = event => setCheckBoxItems({ ...checkBoxItems, [event.target.value]: { turn_on: !checkBoxItems[event.target.value].turn_on } });

  const getPreferencesState = useUpdater('get', {
    url:     '/preference_relations',
    method:  'get',
    headers: { Authorization: `${authToken.get()}` }
  });

  const updatePreferenceState = useUpdater('put', {
    url:     '/preference_relation',
    method:  'put',
    headers: { Authorization: `${authToken.get()}` }
  }, true, () => {
    document.body.dispatchEvent(new CustomEvent('NotificationEvent'));
  });

  useEffect(() => {
    getPreferencesState.callApi();
  }, []);

  useEffect(() => {
    const { loading, data } = getPreferencesState;
    if (!loading && data) {
      const { preferenceRelations } = data;
      const updatedItems = preferenceRelations.reduce((acc, { preferenceTypeCd }) => {
        return {
          ...acc,
          [preferenceTypeCd]: { turn_on: true }
        }
      }, {});
      setCheckBoxItems({
        ...checkBoxItems,
        ...updatedItems
      });
    }
  }, [getPreferencesState.loading]);

  const handleSubmit = () => {
    const preferences = Object.keys(checkBoxItems).map(key => ({
      preference_type: key,
      turn_on:         checkBoxItems[key].turn_on
    }));

    updatePreferenceState.callApi({ preferences });
  };

  return (
    <section className="preference-actions-wrapper">
      <section className="preference-actions-box">
        <header>
          <p>{headerTitle}</p>
        </header>
        <main>
          <div className="enable-notification-box">
            <p className="subtitle">{title}</p>
            {properties.map((item, index) => (
              <CheckboxWithTooltip
                {...item}
                index={index}
                onChange={onChangeCheckBox}
                tooltipConfig={TOOLTIP_CONFIG}
                key={index}
              />
         ))}
          </div>
          <div className="additional-notification-box">
            <p className="subtitle">{additionaltitle}</p>
            {additionalProperties.map((item, index) => (
              <CheckboxWithTooltip
                {...item}
                index={index}
                checked={checkBoxItems[item.value].turn_on}
                onChange={onChangeCheckBox}
                tooltipConfig={TOOLTIP_CONFIG}
                key={index}
              />
         ))}
          </div>
        </main>
      </section>
      <button className="submit-preference" onClick={handleSubmit}>{submitButton}</button>
    </section>
  );
};

PreferenceActionBox.propTypes = {
  locales:                PropTypes.object,
  getListOfNotifications: PropTypes.object
};

export default PreferenceActionBox;
